import { BaseTableRow, getHeaderName, TableProps } from "@/types";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import MoreVertIcon from "../../resources/images/icons-more-vertical.svg";
import { Table } from "./Table";

interface AddressTableTableRow extends BaseTableRow {
  locationId: string;
}

interface AddressTableProps extends TableProps<AddressTableTableRow> {
  onAddressAction?: (event: any, row: AddressTableTableRow) => void;
}

export class AddressTable extends Table<AddressTableTableRow, AddressTableProps> {
  static columns = {
    name: {
      field: "street",
      label: "tableColumns.name"
    },
    actions: {
      field: "actions",
      label: "tableColumns.actions"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [{ type: AddressTable.columns.name }, { type: AddressTable.columns.actions }],
    noRowsMessage: undefined,
    rowHasAction: undefined
  };

  constructor(props: AddressTableProps) {
    super(props);
  }

  getRowId(e: AddressTableTableRow) {
    return this.tableId + "_" + e.locationId;
  }

  initColumns() {
    const { columns, sortable, onAddressAction } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === AddressTable.columns.name)
          this.columns.push({
            field: "street",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true
          });
      }

      if (c.type === AddressTable.columns.actions)
        this.columns.push({
          field: "actions",
          type: "actions",
          filterable: false,
          disableReorder: true,
          align: "right",
          getActions: (params) => [
            <GridActionsCellItem
              icon={<MoreVertIcon />}
              label='Actions'
              onClick={(e) => onAddressAction?.(e, params.row)}
              key={Math.random().toString(36).substring(7)}
            />
          ]
        });
    });
  }
}
